/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, ElementRef, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { SimplePanelService } from './simple-panel.service';
import { Subscription } from 'rxjs';

/**
 * This component displays a menu on the left side of its parent.
 */
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'tcc-simpleMenu, simpleMenu',
    templateUrl: './simple-menu.component.html',
    //styleUrls: ['./simple-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SimpleMenuComponent implements OnDestroy, OnInit {

  @ViewChild('container', { static: true })
  container?: ElementRef;

  @Output()
  readonly isExpandedChange = new EventEmitter<boolean>();

  private _isExpanded: boolean = false;
  private _isExpandable: boolean = false;
  private _isMainMenu: boolean = false;
  private resizeSubscription: Subscription | undefined;

  constructor(private simplePanelSvc: SimplePanelService) {
  }

  /** if true the menu can be expanded */
  @Input()
  set isExpandable(val: boolean) {
    this._isExpandable = val || false;
    if (!this._isExpandable && this._isExpanded) {
      this.isExpanded = false;
    }
  }
  get isExpandable() {
    return this._isExpandable;
  }

  /** gets and sets value for expansion */
  @Input()
  set isExpanded(val: boolean) {
    if ((this._isExpandable || !val) && this._isExpanded !== val) {
      this._isExpanded = val || false;
      this.isExpandedChange.emit(this._isExpanded);
    }
  }
  get isExpanded() {
    return this._isExpanded;
  }

  /** if this is set by more than one component it will cause a conflict */
  @Input()
  set isMainMenu(val: boolean) {
    this._isMainMenu = val || false; // normalize value
    this.updateMainMenuRegistration();
  }
  get isMainMenu() {
    return this._isMainMenu;
  }

  ngOnInit() {
    this.simplePanelSvc.ensureCompatibleHostCss(this.container);
    this.resizeSubscription = this.simplePanelSvc.onResize.subscribe(() => this.simplePanelSvc.ensureCompatibleHostCss(this.container));
  }

  ngOnDestroy() {
    if (this._isMainMenu) {
      this.simplePanelSvc.mainMenu = undefined;
    }
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }
  /**
   * sets the main menu in simple panel service
   */
  private updateMainMenuRegistration() {
    if (this._isMainMenu) {
      this.simplePanelSvc.mainMenu = this;
    }
    else if (this.simplePanelSvc.mainMenu === this) {
      this.simplePanelSvc.mainMenu = undefined;
    }
  }
}
